import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";

const topics = [
    'carrelages',
    'faïences',
    'crédences',
    'chappes traditionnelles',
    'marches extérieures',
    'parquets',
    "douches à l'italienne",
    'dalles sur plot',
    'allées extérieures',
    'pierres de parement'
]



function ChangingTopic({isMobile}) {
    const [topicIndex, setTopicIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setTopicIndex(prev =>
                (prev === topics.length - 1) ? 0 : prev + 1
            );
        }, 3000);
    
        return () => clearInterval(interval); 
    }, []);

    
    return <span className={isMobile ? "xlarge" : ""}><Fade duration={500} key={`rev${topicIndex}`}>{ topics[topicIndex] }</Fade></span>;
    
}

export default ChangingTopic;